module.exports = __webpack_public_path__ + "media/images/navbar-link-icon-704e7f2c.svg";